import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {CreateEditRiskModal} from '@ey/canvascoreservices';
import {currentResource} from '../../../util/utils';
import {clientSideEventNames} from '../../../util/uiconstants';
import Utility from '../../../util/utilityfunctions';
import {getAllEngagementAccounts} from '../../../actions/Account/accountactions';
import {
	clearRisk,
	createAssertionRiskRelation,
	createNewRisk,
	createRiskFormBodyOption,
	deleteAssertionRiskRelation,
	getRiskById,
	updateRisk
} from '../../../actions/Risk/riskactions';
import {getSliceById} from '../../../selectors/Ares/selectors';
import {clearErrors} from '../../../actions/erroractions';
import ErrorSummary from '../ErrorSummary/ErrorSummary';
//import CreateEditRiskModal from './CreateEditRiskModal/src';
import {setIsModalOpen} from '../../../actions/setismodalopen';

export default function CreateEditRiskModalWrapper(props) {
	const {
		sectionId,
		bodyId,
		bodyOptionId,
		isCreate,
		isEdit,
		showModal,
		setShowModal,
		riskId,
		riskTypeArray,
		onClose,
		isManageRisks,
		actions,
		accountToAdd,
		showToast,
		setShowToast,
		resetToShowToast,
		setResetToShowToast
	} = props;

	const [engagementId, accounts, risk] = useSelector((state) => [
		state.engagementId,
		state.accounts,
		isManageRisks ? state.risk?.createEditEstimate : state.risk
	]);

	const dispatch = useDispatch();

	const allAssertions = useSelector((state) => getSliceById(state, '_assertions'));

	const [accountToDisplay, setAccountToDisplay] = useState([]);

	const getAccountsQueryParameters = {
		IncludeAssertions: true
	};

	const actionProps = {};
	if (isManageRisks) {
		actionProps.isManageEstimates = isManageRisks;
	}

	const processAddChanges = (risk) => {
		if (risk) {
			let newRisk = {};
			let createRisk = new Promise((resolve, reject) => {
				let riskDetails = {
					riskName: risk.riskName,
					riskTypeId: risk.riskTypeId
				};
				dispatch(createNewRisk(engagementId, riskDetails, actionProps)).then((risk) => {
					newRisk = risk;
					resolve();
				});
			});
			return Promise.all([createRisk]).then(() => {
				let newRiskRelations = [];
				let reducerModel = [];
				risk.selectedAccounts?.forEach((acct) => {
					acct.selectedAssertions?.forEach((assertion) => {
						/*see if it is in the list of assertions*/
						let existing = acct.assertions.find((a) => a.knowledgeAssertionId === assertion.id);
						if (existing) {
							newRiskRelations.push({assertionId: existing.id});
						} else {
							newRiskRelations.push({accountId: acct.id, knowledgeAssertionId: assertion.id});
						}
						reducerModel.push({assertionId: assertion.id, account: acct});
					});
				});
				if (newRiskRelations.length > 0 && reducerModel.length > 0) {
					dispatch(
						createAssertionRiskRelation(engagementId, newRisk, newRiskRelations, reducerModel, undefined, allAssertions)
					).then(() => {});
				}
				if (actions && actions.length > 1) {
					let action = actions.find(
						(a) =>
							(Number(a.customProperty1) === newRisk.riskTypeId && a.formBodyOptionId === bodyOptionId) ||
							(Number(a.customProperty1) === 0 && a.formBodyOptionId === bodyOptionId) ||
							(a.customProperty1 === null && a.formBodyOptionId === bodyOptionId)
					);
					if (action) {
						let payload = {
							formBodyOptionId: action.formBodyOptionId
						};

						if (riskTypeArray.includes(risk.riskTypeId)) {
							dispatch(
								createRiskFormBodyOption(sectionId, bodyId, engagementId, newRisk, bodyOptionId, payload)
							).then(() => {});
						} else {
							setShowToast(true);
							setResetToShowToast(!resetToShowToast);
						}
					}
				} else if (actions && actions.length === 1) {
					if (actions[0].customProperty1 === null || Number(actions[0].customProperty1) < 4) {
						let payload = {
							formBodyOptionId: actions[0].formBodyOptionId
						};

						if (riskTypeArray.includes(risk.riskTypeId)) {
							dispatch(
								createRiskFormBodyOption(sectionId, bodyId, engagementId, newRisk, bodyOptionId, payload)
							).then(() => {});
						} else {
							setShowToast(true);
							setResetToShowToast(!resetToShowToast);
						}
					}
				}
			});
		}
	};

	const processEditChanges = (risk) => {
		if (risk) {
			let assertionsToDelete = [];
			let assertionsToAdd = [];
			let reducerModel = [];
			risk.newAssertions?.forEach((assertion) => {
				if (assertion.knowledgeAssertionId) {
					assertionsToAdd.push({knowledgeAssertionId: assertion.knowledgeAssertionId, accountId: assertion.accountId});
				} else {
					assertionsToAdd.push({assertionId: assertion.assertionId});
				}
				reducerModel.push({assertionId: assertion.assertionId, account: accounts.byId[assertion.accountId]});
			});
			risk.deletedAssertions?.forEach((assertion) => {
				if (assertion.assertionId) {
					assertionsToDelete.push(assertion.assertionId);
				}
			});
			let addAssertions = new Promise((resolve, reject) => {
				if (assertionsToAdd.length > 0) {
					dispatch(
						createAssertionRiskRelation(engagementId, risk, assertionsToAdd, reducerModel, undefined, allAssertions)
					)
						.then(() => {
							resolve();
						})
						.catch((error) => {
							reject(error);
						});
				} else {
					resolve();
				}
			});

			let deleteAssertions = new Promise((resolve, reject) => {
				if (assertionsToDelete.length > 0) {
					dispatch(deleteAssertionRiskRelation(engagementId, risk, assertionsToDelete))
						.then(() => {
							resolve();
						})
						.catch((error) => {
							reject(error);
						});
				} else {
					resolve();
				}
			});
			return Promise.all([addAssertions, deleteAssertions]).then(() => {
				let riskDetails = {
					id: risk.id,
					riskName: risk.riskName,
					riskTypeId: risk.riskTypeId
				};
				return dispatch(updateRisk(engagementId, riskDetails, actionProps)).then(() => {
					window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
				});
			});
		}
	};

	useEffect(() => {
		if (showModal) {
			dispatch(setIsModalOpen(true));
		} else {
			dispatch(setIsModalOpen(false));
		}
	}, [showModal]);

	useEffect(() => {
		if (risk && risk.id && accountToAdd) {
			// Check if risk already contains accountToAdd
			const accountExists = risk.assertions?.some((assertion) => assertion.accountId === accountToAdd.id);

			// If accountToAdd does not exist in risk, add it
			if (!accountExists) {
				const addedAccount = [...risk.assertions, {accountId: accountToAdd.id, accountName: accountToAdd.accountName}];
				setAccountToDisplay({...risk, assertions: addedAccount});
			}
		}
	}, [accountToAdd, risk]);

	return (
		<>
			{isCreate && (
				<CreateEditRiskModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					getAllAccountsAction={() =>
						getAllEngagementAccounts(Number(engagementId), actionProps, getAccountsQueryParameters)
					}
					accounts={accounts}
					riskDetails={risk}
					labels={currentResource.createEditRiskModalLabels}
					createRiskAction={(risk) => {
						return processAddChanges(risk);
					}}
					onClose={() => {
						dispatch(clearRisk());
						setTimeout(() => {
							onClose && onClose();
						}, 600);
					}}
					theme={Utility.getTheme()}
					showError={showToast}
					errorChildren={showToast && <ErrorSummary />}
				/>
			)}
			{isEdit && (
				<CreateEditRiskModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					getAllAccountsAction={() =>
						getAllEngagementAccounts(Number(engagementId), actionProps, getAccountsQueryParameters)
					}
					accounts={accounts}
					labels={currentResource.createEditRiskModalLabels}
					riskId={riskId || risk?.id}
					riskDetails={accountToDisplay?.id ? accountToDisplay : risk}
					onClose={() => {
						dispatch(clearErrors());
						dispatch(clearRisk(actionProps));
						setTimeout(() => {
							onClose && onClose();
						}, 600);
					}}
					manageRiskAction={(data) => {
						return processEditChanges(data);
					}}
					getRiskById={() =>
						getRiskById(Number(engagementId), Number(riskId || risk.id), {includeAssertions: true}, actionProps)
					}
					theme={Utility.getTheme()}
					showErrorSummary={showToast}
					errorChildren={<ErrorSummary />}
				/>
			)}
		</>
	);
}

CreateEditRiskModalWrapper.propTypes = {
	isCreate: PropTypes.bool,
	isEdit: PropTypes.bool,
	showModal: PropTypes.bool.isRequired,
	setShowModal: PropTypes.func.isRequired,
	riskId: PropTypes.number,
	onClose: PropTypes.func
};
